var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5203_11351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1841 17.4863H7.81592V23.53H16.1841V17.4863Z",
    fill: "#6864F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1622 14.3086V17.485H10.8377V14.3132L13.1622 14.3086Z",
    fill: "#FD8F01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.4176C8.40543 14.4176 5.49146 11.5036 5.49146 7.90906V0.470703H18.5085V7.90906C18.5085 11.5036 15.5946 14.4176 12 14.4176Z",
    fill: "#FDCB50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20901 5.47094C7.20901 3.62331 7.7612 1.90491 8.70873 0.470703H5.49146V7.90906C5.49146 11.5036 8.40543 14.4176 12 14.4176C12.5975 14.4176 13.176 14.3366 13.7256 14.1859C9.95903 13.0783 7.20901 9.59602 7.20901 5.47094Z",
    fill: "#FD8F01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3245 21.9026V19.1133H9.67552V21.9026H14.3245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0165 4.63817L15.4614 2.5625L17.3578 4.01869L15.0799 4.35365L14.7483 5.96043L10.8219 9.57243L9.94147 7.91309L13.0165 4.63817Z",
    fill: "#BC9AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4614 2.5625L15.4331 2.58655L15.1046 4.35003L17.3578 4.01869L15.4614 2.5625Z",
    fill: "#6864F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0602 3.66218L7.31921 3.45898L8.74152 6.47291L9.78326 5.59065L12.2634 8.36934L14.7355 6.202L12.0602 3.66218Z",
    fill: "#BC9AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73022 5.60811L12.2104 8.38684L14.6825 6.2195L12.0072 3.67969L9.73022 5.60811Z",
    fill: "#6864F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94149 7.91406L9.26422 11.673L12.1766 12.1133L9.94149 7.91406Z",
    fill: "#6864F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77763 10.1424C3.2101 10.1424 1.30737 8.15201 1.30737 5.58444V1.40039H5.49142",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1152 10.1424C20.6827 10.1424 22.6926 8.15201 22.6926 5.58444V1.40039H18.5085",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.184 17.4863V23.53",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81592 23.53V17.4863",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8378 17.4863V14.3145",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1622 14.3086V17.485",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.4176C8.40543 14.4176 5.49146 11.5036 5.49146 7.90906V0.470703H18.5085V7.90906C18.5085 11.5036 15.5946 14.4176 12 14.4176Z",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65369 17.4863H17.3463",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3463 23.5293H6.65369",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.013 4.67693L15.3794 2.58398L17.2565 4.01683L14.9407 4.63194",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3794 2.58398L14.6085 6.18271L10.7874 9.48158",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6085 6.18343L11.9605 3.68433L7.26782 3.48438L8.67563 6.45002L11.9605 3.68433",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3132 8.16382L9.64484 5.63281",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9596 6.88086L9.91584 7.84928L9.24548 11.548L12.1281 11.9812L9.91584 7.84928",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5203_11351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantIcon3);
export default __webpack_public_path__ + "static/media/assistant-icon-3.a608a82cdc45fc6d9404b53b332429a8.svg";
export { ForwardRef as ReactComponent };